'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _modal = require('../../redux/modules/modal');

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _react = require('react');

var _reactRedux = require('react-redux');

var _user = require('../../redux/modules/user');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnsureLoggedInContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var loginModalOpen = openModal === 'LOGIN';

    return {
        loginModalOpen: loginModalOpen,
        userLoggedIn: userLoggedIn
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openLoginModal: _modal.openLoginModal,
        push: _reactRouterRedux.push
    }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(EnsureLoggedInContainer, _Component);

    function EnsureLoggedInContainer() {
        (0, _classCallCheck3.default)(this, EnsureLoggedInContainer);
        return (0, _possibleConstructorReturn3.default)(this, (EnsureLoggedInContainer.__proto__ || (0, _getPrototypeOf2.default)(EnsureLoggedInContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(EnsureLoggedInContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.userLoggedIn) {
                this.props.openLoginModal();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.loginModalOpen && !nextProps.userLoggedIn) {
                // From a route that requires a login, logout should send back to the homepage
                this.props.push({
                    pathname: '/'
                });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'loginModalOpen', 'userLoggedIn']);
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.userLoggedIn ? this.props.children : null;
        }
    }]);
    return EnsureLoggedInContainer;
}(_react.Component), _class2.defaultProps = {
    loginModalOpen: false
}, _temp)) || _class);
exports.default = EnsureLoggedInContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EnsureLoggedIn/EnsureLoggedInContainer.js
// module id = OylW
// module chunks = 57